enum DateEnum {
  'HHmmss' = 'HHmmss',
  'HH:mm:ss' = 'HH:mm:ss',
  'HHmm' = 'HHmm',
  'HH:mm' = 'HH:mm',
  'yyyyMMdd' = 'yyyyMMdd',
  'yyyy/MM/dd' = 'yyyy/MM/dd',
  'yyyy年MM月dd日' = 'yyyy年MM月dd日',
  'yyy/MM/dd' = 'yyy/MM/dd',
  'yyyMMdd' = 'yyyMMdd',
  '民國 yyy/MM/dd' = '民國 yyy/MM/dd',
  'y/MM/dd' = 'y/MM/dd',
  'yyyyMMdd HHmmss' = 'yyyyMMdd HHmmss',
  'yyyyMMddHHmmss' = 'yyyyMMddHHmmss',
  'yyyy/MM/dd HH:mm:ss' = 'yyyy/MM/dd HH:mm:ss',
  'yyyyMMdd HHmm' = 'yyyyMMdd HHmm',
  'yyyy/MM/dd HH:mm' = 'yyyy/MM/dd HH:mm',
  'yyyy/MM' = 'yyyy/MM',
}

// #region format const
// export const dDaFms = [DateEnum.daFormat, DateEnum.daFormatP];
// export const dDaTi4s = [DateEnum.daTi4Format, DateEnum.daTi4FormatP];
// #endregion

export default DateEnum;
